import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import UserAvatar from '../../../User/Avatar';
import { useCurrentUser } from '../../../utils/hooks/useCurrentUser';

export interface Props {
  withLink?: boolean;
  className?: string;
}

/** An avatar that will sit alongside our comment box. It's just our `<UserAvatar />` with some predefined fields. */
const CommentBoxAvatar: React.FC<Props> = ({ withLink, className }) => {
  const currentUser = useCurrentUser();
  const isMobile = useContext(MobileContext);
  return (
    <UserAvatar
      user={currentUser}
      size={isMobile ? 24 : 32}
      className={className}
      withLink={withLink}
    />
  );
};
CommentBoxAvatar.displayName = 'CommentBoxAvatar';

export default CommentBoxAvatar;
